import { render, staticRenderFns } from "./TotalizerOverview.vue?vue&type=template&id=04f61a5c&scoped=true"
import script from "./TotalizerOverview.vue?vue&type=script&lang=js"
export * from "./TotalizerOverview.vue?vue&type=script&lang=js"
import style0 from "./TotalizerOverview.vue?vue&type=style&index=0&id=04f61a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f61a5c",
  null
  
)

export default component.exports